<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="类别主键枚举值" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.typeKey" placeholder="请输入类别主键枚举值">
						</el-input>
					</el-form-item>
					<el-form-item label="类别名称" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.typeName" placeholder="请输入类别名称">
						</el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status" class="big" placeholder="请选择状态" clear>
							<el-option :key="0" label="未启用" :value="0">未启用</el-option>
							<el-option :key="1" label="正常" :value="1">正常</el-option>
						
							
						</el-select>
					</el-form-item>
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<!-- <el-table-column prop="position" label="业务类别" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="typeName" label="类别名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="typeKey" label="类别主键枚举值" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="typeMemo" label="类别描述" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="orderIndex" label="排序" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0">未启用</span>
					<span v-if="scope.row.status==1">正常</span>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="100px">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title+'类别'" @close="addDialogClose" width="620px"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="类别名称" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.typeName"
							auto-complete="off" placeholder="请输入类别名称" />
					</el-form-item>
					<el-form-item label="类别主键枚举值" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.typeKey"
							auto-complete="off" placeholder="请输入类别主键枚举值" />
					</el-form-item>
					
					<el-form-item label="是否启用" label-width="120px">
						<el-switch v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false"
							class="switchss">
						</el-switch>
					</el-form-item>
                    <el-form-item label="类别说明" label-width="120px">
                        <el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.typeMemo"
                            auto-complete="off" placeholder="请输入类别说明" />
                    </el-form-item>
                    <el-form-item label="排序" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.orderIndex"
							auto-complete="off" placeholder="请输入排序号" />&nbsp;<span id="">
								数值越大，排序越靠前
							</span>
					</el-form-item>
					<el-button type="primary" v-if="title=='添加'" @click="submit">提交</el-button>
					<el-button type="primary" v-else @click="submitClick">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false">
			<el-carousel indicator-position="outside" style="height: 600px;">
				<el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
					<img :src="item" style="width: 100%; height: 100%;" />
				</el-carousel-item>
			</el-carousel>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>
		<el-dialog  :visible.sync="dialogIntroVisible" title="详情">
			<div v-html="storeIntro" style="height: 600px;overflow-y: scroll;"></div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
					httpUrl: urls+'?type=2023',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				unitList:[],
				storeIntro:'',
				dialogIntroVisible:false,
				expressList: [],
				dialogImageUrl:[],
				dialogVisibleImg:false,
				title:'',
				orderInfo: {},
				sliderlist:{},
				goodsImages:[],
				storeGoodsInfo: {},
				fileList:[],
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				}

			}
		},
		methods: {
			lookxq(storeIntro){
				this.dialogIntroVisible=true
				this.storeIntro=storeIntro
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					 ...this.orderInfo
					// name:this.orderInfo.name
				}
				this.$api.getStateOFGoodsList(data).then((res) => { 
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			lookzj(img){
				this.dialogImageUrl=img.split(',')
				// console.log(this.dialogImageUrl);
				this.dialogVisibleImg=true
			},
			// 新增
			addCarousel() {
			
				this.dialogVisibleSwiper = true
				this.title='添加'
			},

			// 提交
			submit() {
				let data = {
					...this.storeGoodsInfo,
				}
				this.$api.addStateOFGoodsInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.title='编辑'
				this.$api.getStateOFGoodsInfoByID(e).then((res) => {
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data
						this.dialogVisibleSwiper = true
					}
				})

			},
			// 编辑修改提交
			submitClick() {
				// console.log();
				let data = {
					...this.storeGoodsInfo,
				}
				this.$api.updateStateOFGoodsInfo(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该类别, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delStateOFGoodsInfoByID(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
			},
		},




		created() {
			this.findPmsUnit()
		
		}
	}
</script>

<style>

</style>
